// Allows only digits, limits to 6 characters
export function filterPincodeInput(value) {
    return value.replace(/\D/g, '').slice(0, 6);
}

// Returns true if the key event should be allowed (digits, navigation, backspace, etc.)
export function isAllowedPincodeKey(event) {
    const allowedKeys = [
        'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
    ];
    if (allowedKeys.includes(event.key)) return true;
    // Allow only digits
    return /\d/.test(event.key);
}
export const capitalizeFirst = (string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const getModuleName = (name) => {
    let result = name.replace(/([A-Z])/g, ' $1');
    result = result.charAt(0).toUpperCase() + result.slice(1).toLowerCase();
    return result;
}

export function truncateString(str, length = 10, suffix="...") {
    if (str.length > length) {
        return str.substring(0, length) + suffix;
    }
    return str;
}

export function handleCopy(fullText) {
    navigator.clipboard.writeText(fullText)
}

export function toCamelCase(str, firstCapital=false) {
    let result = str
        .replace(/[_\s]+/g, ' ') 
        .split(' ')
        .map((word, index) => 
            index === 0 
                ? word.toLowerCase()
                : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join('');
    
    if(firstCapital){
        result = result.charAt(0).toUpperCase() + result.slice(1)
    }

    return result;
}

export function formatUploadLogData(data) {
    const result = Object.fromEntries(
        Object.entries(data).map(([key, value]) => [
            toCamelCase(key), 
            value
        ])
    )
    result.fileRowCount = result.rowCount
    result.fileColCount = result.colCount
    result.fileSizeInMB = result.sizeInMB
    if(result.Id) delete result.Id
    return result
}

export function getCamelCasedKeys(data) {
    return Object.fromEntries(
        Object.entries(data).map(([key, value]) => {
            let newKey;

            if (key === 'size_in_mb') {
                newKey = 'sizeInMB';
            } else {
                newKey = toCamelCase(key);
            }

            return [newKey, value];
        })
    );
}

export const isValidObjectId = (value) => {
  if (typeof value !== "string") return false;

  // Must be 24 hex chars AND contain at least one letter (a-f)
  const objectIdRegex = /^(?=.*[a-fA-F])[0-9a-fA-F]{24}$/;

  return objectIdRegex.test(value);
};

export const getValueForObjId = (data=[], id) => {
    const result = data.find(item => item.value === id);
    return result ? result.label : null;
}

export function extractValues(str) {
    if(str && str.includes("(") && str.includes(")")){
        str = str.trim();
        const [firstPart, secondPartWithClosingParenthesis] = str.split('(');
        const secondPart = secondPartWithClosingParenthesis.replace(')', '').trim();
        return {
            destName: firstPart.trim(),
            typeName: secondPart
        };
    }
    else return false
}

export function getMappedCols(columns, maps, destinationColumns){
    const result = columns
    .filter(col => Object.keys(maps).includes(col['Input_Column']))
    .map(col => {
        const mappedCol = maps[col['Input_Column']];
        return {
            ...col,
            "Mapped_Column": mappedCol,
            "Mapped_DataType": destinationColumns[mappedCol]
        };
    });
    return result;
}

export function getAdditionalCols(columns, maps){
    const result = columns
    .filter(col => Object.keys(maps).includes(col['Input_Column']))
    .map(col => {
        const mappedItem = maps[col['Input_Column']];
        return {
            ...col,
            selected: true,
            "Mapped_Column": Object.keys(mappedItem)[0],
            "Mapped_DataType": capitalizeFirst(mappedItem[Object.keys(mappedItem)[0]])
        };
    });
    return result;
}

export function getEtlAddCols(columns) {
    // columns.map((key, col) => ({key: }))
    return columns;
}

export function camelToSentenceCase(str) {
    return str
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .replace(/^./, (match) => match.toUpperCase());
}

export function getPageLoadDataKey(index) {
    const list = ["sourceTypes", "masterProjects", "projects", "vendors", "channelPartners", "users", "dataCategories", "leadSources"]
    const value = ["sourceType", "masterProject", "project", "vendor", "channelPartner", "spoc", "dataCategory", "leadSource"]

    const valueIndex = value.indexOf(index);
    return valueIndex !== -1 ? list[valueIndex] : null;
}

export const dashesToUnderscores = (str) => {
    return str.replaceAll("-", "_");
}

export const spacesToUnderscores = (str) => {
    return str.replaceAll(" ", "_");
}

export const underscoresToSpaces = (str) => {
    return str.replaceAll("_", " ");
}

export const cleanArray = (arr) =>
(arr || []).filter(
    (obj) =>
        obj &&
        Object.values(obj).every(
        (v) => v !== null && v !== undefined
        )
);

export function toTitleCase(str) {
    if (!str || typeof str !== "string") return "";

    return str
        .toLowerCase()
        .trim()
        .split(/\s+/)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
}
